import {
  useAccount,
  useHasEntitlement,
  useHasOrganizationAction,
} from '~publish/contexts/AccountContext'

interface UseCanAccessTeamFeaturesReturn {
  canAccessTeamFeatures: boolean
  isLoading: boolean
}

export const useCanAccessTeamFeatures = (): UseCanAccessTeamFeaturesReturn => {
  const { account } = useAccount()
  const canViewTeamMembers = useHasOrganizationAction('viewTeamMembers')
  const hasAccessTeamPanel = useHasEntitlement('teamsPanel')
  const canAccessTeamFeatures = hasAccessTeamPanel && canViewTeamMembers
  const isLoading = !account

  return {
    canAccessTeamFeatures,
    isLoading,
  }
}
